import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors as c } from '../../../styles/Variables'

export const PackagesWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${c.white};
  overflow-x: hidden;
  box-sizing: border-box;


  .hero-class {
    width: 100%;
    .hero-container {
      width: 100%;
      max-width: 1600px;
  
      .hero-container-inner {
        width: 100%;

        ${mq('max', '768px')} {
          height: 900px;
        }

        .content, .image-placeholder {
          min-width: 50%;
        }
      }
  
    }
  }



  .faq-wrapper {
    /* padding: 50px 20px; */
    padding-top: 110px;
    width: 100vw;
    background-color: ${c.white};
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .gift-link-wrapper {
    max-width: 1600px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    padding: 31px 0;
    gap: 40px;

    width: 100%;
    color: #000;
    text-align: center;
    font-family: Euclid;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background-color: ${c.greyBelowHero};

    ${mq('max', '768px')} {
        flex-direction: column;
        gap: 0;
        padding: 30px 0;
    }

    .visit-gift-button {
      ${mq('max', '768px')} {
        border: none;
        font-size: 18px;
        color: ${c.sunsetOrange};
      }
    }
  }

  .content-container {
    max-width: 624px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;    

    ${mq('max', '768px')} {
      max-width: 100%;
      margin: 75px 0 0;
    }

    .subtitle {
      max-width: 650px;
      margin: 40px 0;
      text-align: center;
    }

    .packages-content {
      margin-top: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      h1 {
        font-size: 62px !important;
      }

      ${mq('max', '768px')} {
        width: 80%;
      }

      ${mq('max', '640px')} {
        width: 100%;
        padding: 0 16px;
      }

    }

    .package-steps {
      width: 100%;
      
      .step-1 {
        padding: 50px 0;
        display: flex;
        flex-direction: column;        
        align-items: center;

        .market-selector-container {
          padding-top: 20px;
          width: 100px;
        }

        ${mq('max', '768px')} {
          padding: 20px 0;
        }
      }

      .step-2 {
        &:focus {
          outline: none;
        }
        display: flex;
        flex-direction: column;        
        align-items: center;        
      }
    }
  }

  .packages-container {
    margin: 20px 0;
    width: 100%;
    
    .package-card {
      /* width: 624px; */
      max-height: fit-content;
      margin: 10px 0;
      padding: 28px 20px;
      display: flex;
      flex-wrap: wrap;
      background-color: ${c.white};
      border: 1px solid ${c.lightTangerine};

      &:hover {
        cursor: pointer;
      }

      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 10px 0;

        ${mq('max', '768px')} {
          width: 361px;
        }

        ${mq('max', '550px')} {
          flex-basis: 100%;
        }

        .product-name {
          color: ${c.black};
          font-family: Euclid;
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: 140%; /* 28px */
        }

        .product-description {
          color: ${c.cobalt};
          font-family: Euclid;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 18px; /* 100% */
          letter-spacing: 0.54px;
          text-transform: uppercase;
        }

        .product-price {
          display: block;
          position: relative;
          right: 0;
          color: #000;
          font-family: Euclid;
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%; /* 28px */
          letter-spacing: 0.2px;          
        }
      }
    }

    .selected-package {
      border: 1px solid ${c.sunsetOrange};
    }
  }

  .select-product-button {
    margin: 30px 0;    

      ${mq('max', '768px')} {
        width: 100%;

        button {
          max-width: initial !important;
          width: 100% !important;
        }
      }
  }
`
